<template>
  <the-table-page :titleTable="$t('Услуги поставщика')"
                  :tableData="tableData"
                  :load="load"
                  fieldId="childId"
                  :updateData="updateData"
                  :fieldInfoList="fieldInfoList"
                  :searchStart="searchStart"
                  :sortData="sortData"
                  :setSort="setSort"
                  :deleteEl="deleteEl"
                  :prefixEdit="``"
                  :linkCreate="`/company/supplier/${$route.params.CompanyId}/supplierService/create`"
                  configName = "supplierService"
                  :roleName="nameRoleEntity"  
                  :hasReadOnlyInTable="hasReadOnlyInTable" 
  ></the-table-page>
</template>
<script>

  import TheTablePage from "../../../TheTablePage.vue";
  import {SUPPLIER_SERVICE} from "../store/type";

  import {
    SET_MAIN_PAGINATION,
    SET_MAIN_PAGINATION_PER_PAGE,
    SET_MAIN_PAGINATION_PAGE,
    SET_MAIN_SORT_ENTITY,
    SET_MAIN_SEARCH_ENTITY
  } from "../../../../store/type"

  import {READ, DELETE} from '../../../../store/type'
  import {mapState} from 'vuex';
  import NotificationSample from 'src/pages/Dashboard/Components/NotificationSample';
  import {DEFAULT_PER_PAGE, TYPE_ERRORS, GET_MEMORY_PER_PAGE} from '../../../../constant'
  import notify from '../../../../helpers/notify/notify'
  import convertLangDataToTable from '../../../../helpers/converters/convertLangDataToTable'
  import {NAME_OBJECT} from "../../../../RoleConstanans"
  export default {
    props:{
         hasReadOnlyInTable: { type: Boolean, default: true }, 
    },
    components: {
      TheTablePage
    },
    data() {
      return {
        scheme: {},
        load: false
      }
    },
    computed: {
      ...mapState({
        fieldInfoList: state => state.company.fieldInfoList,
        lang: state => state.common.lang,
        sortData: state => state.pagination.sortData,
      }),
      nameRoleEntity(){
        return NAME_OBJECT.supplierService
      },
      tableData() {
          let langNow = this.$store.state.common.lang
          let dataNow = this.$store.state.company.data || []
          if (dataNow && dataNow.length > 0) {
            dataNow = convertLangDataToTable(dataNow, langNow, '', false)
            return dataNow
          }
      }
    },
    watch: {
      lang() {
        this.initData()
      }
    },
    methods: {
      getData() {
        this.load= true
        this.$store.dispatch(SUPPLIER_SERVICE + READ, {
            self:this,
            CompanyId: this.$route.params.CompanyId,
        }).then(res=>{
          this.load= false
        })
        .catch(err=>{
          this.load= false
          notify(this, this.$t('Ошибка получения данных'), TYPE_ERRORS.DANGER)
        })
      },
      updateData() {
        this.getData()
      },
      searchStart(search){
        this.$store.commit(SET_MAIN_SEARCH_ENTITY, search)
        this.getData()
      },
      setSort(val){
        this.$store.commit(SET_MAIN_SORT_ENTITY, val)
        this.getData()
      },
      deleteEl(id){
          this.$store.dispatch(SUPPLIER_SERVICE + DELETE, {
             childId:  id,
             parentId: this.$route.params.CompanyId,
            self: this
          }).then(res => {
            this.getData()
               if(res.errors && res.errors.length  == 0){notify(this, this.$t("Успешно"),TYPE_ERRORS.SUCCESS); }
          })
      },
      initData() {
        this.$store.commit( SUPPLIER_SERVICE + READ ,{ data: [], fieldInfoList: []})
        this.$store.commit( SET_MAIN_SORT_ENTITY,{})
        this.$store.commit( SET_MAIN_SEARCH_ENTITY, '')
        this.$store.commit( SET_MAIN_PAGINATION_PER_PAGE, GET_MEMORY_PER_PAGE())
        this.$store.commit( SET_MAIN_PAGINATION_PAGE, 1)
        this.getData()
      }
    },
    created() {
      this.initData()
    }
  }
</script>
